import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface GetFaxStatusResponse {
  RmiActiveRec: string
  RmiCompanyId: string
  RmiCreatedBy: string
  RmiCreatedDate: string
  RmiDescr: string
  RmiLetterTypeCode: string
  RmiModifiedBy: string
  RmiModifiedDate: string
  RmiType: string
}

export interface ProviderList {
  PKey: string
  Provider: string
  RmiAccount: string
  RmiActive: string
  RmiActiveRec: string
  RmiAddressId: number
  RmiAssociate: string
  RmiAuthAccess: string
  RmiAuthReviewDays: string
  RmiBirthDate: string
  RmiCity: string
  RmiClaimAccess: string
  RmiClaimAccessDays: number
  RmiClass: string
  RmiCompanyId: string
  RmiContact: string
  RmiContract: string
  RmiCreatedBy: string
  RmiCreatedDate: string
  RmiDaysToTerm?: string
  RmiEmail: string
  RmiEthnicity: string
  RmiFirstName: string
  RmiFromDate: string
  RmiFullName: string
  RmiLastName: string
  RmiMi: string
  RmiModifiedBy: string
  RmiModifiedDate: string
  RmiProvId: string
  RmiProvKeyId: string
  RmiProvMpiNo: string
  RmiRemark: string
  RmiRetroAuthDays?: string
  RmiRevFullName: string
  RmiSequence: string
  RmiSex: string
  RmiStreet: string
  RmiSubAcct: string
  RmiSuffix: string
  RmiTermDate?: string
}

export interface GetAuthEnabledProviderListResponse {
  PKey: string
  Provider: string
  RmiAccount: string
  RmiActive: string
  RmiActiveRec: string
  RmiAddressId: number
  RmiAssociate: string
  RmiAuthAccess: string
  RmiAuthReviewDays: null
  RmiBirthDate: string
  RmiCity: string
  RmiClaimAccess: string
  RmiClaimAccessDays: string
  RmiClass: string
  RmiCompanyId: string
  RmiContact: string
  RmiContract: string
  RmiCreatedBy: string
  RmiCreatedDate: string
  RmiDaysToTerm?: string
  RmiEmail: string
  RmiEthnicity: string
  RmiFirstName: string
  RmiFromDate: string
  RmiFullName: string
  RmiLastName: string
  RmiMi: string
  RmiModifiedBy: string
  RmiModifiedDate: string
  RmiProvId: string
  RmiProvKeyId: string
  RmiProvMpiNo: string
  RmiRemark: string
  RmiRetroAuthDays?: string
  RmiRevFullName: string
  RmiSequence: string
  RmiSex: string
  RmiStreet: string
  RmiSubAcct: string
  RmiSuffix: string
  RmiTermDate: string
}

export interface ProviderForAuthSubmissionCheck {
  ProvId: string
  ProvKeyId: string
  CompanyId: string
  PosCode: string
  SpecCode: string
}

// TODO: change into GET request on backend, or rename to POST request here.
export const getProviderWithVendorInfo = (rmiProvKeyId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_WITH_VENDOR_INFO_REQUEST, payload: rmiProvKeyId });

  return api.authorization.provider.getProviderWithVendorInfo(rmiProvKeyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_WITH_VENDOR_INFO_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_WITH_VENDOR_INFO_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getProviderName = (providerKeyId: any, companyId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_NAME_REQUEST });

  return api.authorization.provider.getProviderName(providerKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_NAME_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_NAME_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

// TODO: combine with isArcadia?
export const isPcp = (providerKeyId: any, companyId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.IS_PCP_REQUEST });

  return api.authorization.provider.isPcp(providerKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.IS_PCP_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.IS_PCP_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const isArcadia = (providerKeyId: any, companyId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

    dispatch({ type: types.IS_ARCADIA_REQUEST });

    return api.authorization.provider.isArcadia(providerKeyId, companyId)
      .then((res: any) => {

        dispatch({
          type: types.IS_ARCADIA_SUCCESS,
          payload: res,
        });

        return res;
      })
      .catch((err: Error) => {
        const msg = _get(err, 'response.data.msg', 'Get failed!');
        const errors = _get(err, 'response.data.errors', {});
        const payload = { ...err, msg, errors };

        dispatch({
          type: types.IS_ARCADIA_FAILURE,
          payload,
        });

        return Promise.reject(payload);
      });
  };



export const getIpaAdvise = (companyId: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_IPA_ADVISE_REQUEST });

  return api.authorization.provider.getIpaAdvise(companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_IPA_ADVISE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_IPA_ADVISE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getProviderHccMembersLob = (providerKeyId: string, lob: string, userId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_AUTH_PROVIDER_HCC_REQUEST });

  if (lob === 'ALL') lob = '';
  return api.authorization.provider.getProviderHccMembersLob(providerKeyId, lob, userId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_AUTH_PROVIDER_HCC_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_AUTH_PROVIDER_HCC_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
}

// post request
export const getAuthSearchProviderList = (userModel: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_AUTH_SEARCH_PROVIDER_LIST_REQUEST });

  return api.authorization.provider.getAuthSearchProviderList(userModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_AUTH_SEARCH_PROVIDER_LIST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'err.message', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {}); // TODO
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_AUTH_SEARCH_PROVIDER_LIST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

// post request
export const getProviderByCity = (searchObject: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_BY_CITY_REQUEST });

  return api.authorization.provider.getProviderByCity(searchObject)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_BY_CITY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_BY_CITY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

// post request
export const getProviderByName = (searchObject: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PROVIDER_BY_NAME_REQUEST });

  return api.authorization.provider.getProviderByName(searchObject)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_BY_NAME_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_BY_NAME_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

// post request
export const getAuthEnabledProviderList = (userModel: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_AUTH_ENABLED_PROVIDER_LIST_REQUEST });

  return api.authorization.provider.getAuthEnabledProviderList(userModel)
    .then((res: any) => {

      dispatch({
        type: types.GET_AUTH_ENABLED_PROVIDER_LIST_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_AUTH_ENABLED_PROVIDER_LIST_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const acknowledgement = (ackTypes: any, membKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authProvider.isPostingAck) { return Promise.reject(); }

  dispatch({ type: types.POST_ACKNOWLEDGEMENT_REQUEST });

  return api.authorization.provider.acknowledgement(ackTypes, membKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.POST_ACKNOWLEDGEMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_ACKNOWLEDGEMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const checkInitialFollowUp = (companyId: string, membKeyId: string, provKeyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.CHECK_INITIAL_FOLLOW_UP_REQUEST });

  return api.authorization.provider.checkInitialFollowUp(companyId, membKeyId, provKeyId)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_INITIAL_FOLLOW_UP_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_INITIAL_FOLLOW_UP_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getAllIpaProviders = (companyId: string, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_ALL_IPA_PROVIDERS_REQUEST });

  return api.authorization.provider.getAllIpaProviders(companyId, userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_ALL_IPA_PROVIDERS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ALL_IPA_PROVIDERS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const searchAllByName = (val: string, userId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.SEARCH_ALL_PROVIDERS_REQUEST });

  return api.authorization.provider.searchAllByName(val, userId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.SEARCH_ALL_PROVIDERS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SEARCH_ALL_PROVIDERS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getCECProviders = (userId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CEC_PROVIDERS_REQUEST });

  return api.authorization.provider.getCECProviders(userId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_CEC_PROVIDERS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CEC_PROVIDERS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getProviderTermDate = (userId: string, provKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_PROVIDER_TERM_DATE_REQUEST });

  return api.authorization.provider.getProviderTermDate(userId, provKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_TERM_DATE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_TERM_DATE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getEzCapProviderDetails = (provKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_EZ_PROVIDER_DETAILS_REQUEST });

  return api.authorization.provider.getEzCapProviderDetails(provKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_EZ_PROVIDER_DETAILS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_EZ_PROVIDER_DETAILS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const checkProviderForAuthSubmission = (request: ProviderForAuthSubmissionCheck) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_CHECK_PROVIDER_AUTH_SUBMISSION_REQUEST});

  return api.authorization.provider.checkProviderForAuthSubmission(request.ProvId, request.ProvKeyId, request.CompanyId, request.PosCode, request.SpecCode)
    .then((res: boolean) => {

      dispatch({
        type: types.GET_CHECK_PROVIDER_AUTH_SUBMISSION_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CHECK_PROVIDER_AUTH_SUBMISSION_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};